import axios from "axios";
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentStakeholder } from "../../../@types/documentStakeholder";
import axiosInstance from "../../../utils/axiosConfig";

export const notifySignerByWhatsapp = createAsyncThunk(
  "documentShow/notifySignerByWhatsapp",
  async (
    {
      documentStakeholder,
      typeNotification,
    }: { documentStakeholder: DocumentStakeholder; typeNotification: number },
    { rejectWithValue }
  ) => {
    try {
      if (typeNotification === 1) {
        const { data } = await axiosInstance.post(`${api.baseURL}document/send-message`, {
          idPerson: documentStakeholder.stakeholder?.id,
          message: `El acuerdo ${documentStakeholder.document?.title} ya está disponible para su firma. Para firmar visite https://mi.guardservice.cl/app/acuerdos/firma/${documentStakeholder.document?.id}`,
        });
        return data;
      }
      if (typeNotification === 2) {
        const { data } = await axiosInstance.post(`${api.baseURL}document/send-message`, {
          idPerson: documentStakeholder.stakeholder?.id,
          message: `Usted tiene documentos pendientes para firmar. Por favor, visite https://mi.guardservice.cl/app/acuerdos/pendientes`,
        });
        return data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
